import { FC } from 'react'
import { Tags, TagsType } from './Tags'
import { TagTag, TagTagType } from './TagTag'

export const Tag: FC & TagTagType & TagsType = (): JSX.Element => <></>

Tag.Tag = TagTag
Tag.Tags = Tags
